import { Stack, type StackProps } from '@mui/joy';
import { type ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import ErrorMessage from '../errors/ErrorMessage';

const CognitoApiErrorMessage = ({
  justify = 'center',
}: {
  justify?: StackProps['justifyContent'];
}): ReactElement | null => {
  const context = useFormContext();
  const error = context.formState.errors.cognitoApiError;
  // @ts-ignore
  const errorMessage: string | undefined = error?.message;

  useEffect(() => {
    const subscription = context.watch((_, { name }) => {
      if (name && name !== 'cognitoApiError' && context.formState.errors.cognitoApiError) {
        context.clearErrors('cognitoApiError');
      }
    });

    return () => subscription.unsubscribe?.();
  }, [context]);

  if (errorMessage) {
    return (
      <Stack justifyContent={justify} spacing={1.5}>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </Stack>
    );
  }

  return null;
};

export default CognitoApiErrorMessage;
